import { memo } from 'react'

import { ICONS } from './icons'
import type { IconProps } from './types'

/**
 * Типизированная инлайн-иконка. Один язык: контур, currentColor, без заливки
 * (кроме мелких точек-глаз/центра — они закрашены currentColor).
 */
export const Icon = memo(function Icon(props: IconProps) {
  const { name, size = 20, strokeWidth = 1.5 } = props
  const glyph = ICONS[name]

  return (
    <svg
      width={size}
      height={size}
      viewBox={glyph.viewBox}
      fill='none'
      stroke='currentColor'
      strokeWidth={strokeWidth}
      strokeLinecap='round'
      strokeLinejoin='round'
      aria-hidden='true'
      focusable='false'
    >
      {glyph.paths?.map((d) => (
        <path key={d} d={d} />
      ))}
      {glyph.circles?.map((circle) => (
        <circle
          key={`${circle.cx}-${circle.cy}-${circle.r}`}
          cx={circle.cx}
          cy={circle.cy}
          r={circle.r}
        />
      ))}
      {glyph.rects?.map((rect) => (
        <rect
          key={`${rect.x}-${rect.y}-${rect.width}`}
          x={rect.x}
          y={rect.y}
          width={rect.width}
          height={rect.height}
          rx={rect.rx}
        />
      ))}
      {glyph.dots?.map((dot) => (
        <circle
          key={`dot-${dot.cx}-${dot.cy}`}
          cx={dot.cx}
          cy={dot.cy}
          r={dot.r}
          fill='currentColor'
          stroke='none'
        />
      ))}
    </svg>
  )
})
